module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAD3RSTlMAHAgR6BicheyVjVoB0D4dXceUAAAAUUlEQVQY02MgAEoSULj/v6JyP8JYTI8gXNatYK7KXwj3yA8FEFf+P4Sr/9+AhtzoAGQuU78PMpf5/6cB5n6FceP/QwKWy5OBYcoCBjZ3AnEAAFNUdeZdaLn0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no_live.png
// module id = b+X2
// module chunks = 2 3 4 6 7 8 9